
import Vue, {PropOptions} from 'vue';

type Options = {
  closable?: boolean
  closeOnClickOutside?: boolean
}


export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      required: true
    } as PropOptions<boolean>,
    windowClass: {
      type: String,
      default: ''
    } as PropOptions<string>,
    options: {
      type: Object,
      default: {}
    } as PropOptions<Options>,
  },
  computed: {
    vClickOutside() {
      // We use this only to change 'click' event into 'mousedown' event, so when
      // somebody performs presses mouse button inside modal and then moves mouse
      // outside and releases the button, the modal will NOT close.
      // @ts-ignore: for some reason `this.isTouch` is not recognized by typescript
      const EVENTS = this.$isTouchScreen ? ['touchstart'] : ['mousedown'];

      return {
        handler: () => this.emitClose(),
        events: EVENTS
      }
    }
  },
  methods: {
    emitClose() {
      this.$emit('close');
      this.$emit('update:visible', false);
    }
  }
})
